import React from 'react';
import { Section } from './Section';
import { Heart } from 'lucide-react';
export function ProofSection() {
  return <Section className="bg-forest text-cream" data-id="element-96">
      <div className="text-center mb-8" data-id="element-97">
        <Heart className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-98" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-99">
          ¿Qué cambia en 72 horas?
        </h2>
      </div>
      <div className="max-w-3xl mx-auto text-center" data-id="element-100">
        <p className="text-xl leading-relaxed text-cream-dark font-medium" data-id="element-101">
          No solo verás tu abdomen más plano en el espejo. Te despertarás sin
          esa neblina mental, tus niveles de energía se mantendrán estables todo
          el día y sentirás una sensación de alivio físico que hace meses (o
          años) no sentías. Es el "reset" que tu cuerpo ha estado pidiendo a
          gritos.
        </p>
      </div>
    </Section>;
}